<template>
  <div class="text-center flex flex-col items-center">
    <div
      class="w-20 h-20 rounded-full bg-blue flex items-center justify-center mb-6"
    >
      <img :src="icon" alt="" class="w-10" />
    </div>
    <h4 class="text-blue font-bold mb-4">
      {{ title }}
    </h4>
    <p class="text-sm">
      {{ copy }}
      <template v-if="link">
        <br />
        <a :href="link" target="_blank" class="block text-center text-blue">
          {{ $t('howtoMore') }} >
        </a>
      </template>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    copy: {
      type: String,
      required: true
    },
    link: {
      type: String,
      default: ''
    }
  }
};
</script>

<style></style>
